import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { STORAGE } from "src/app/constant/storages";
import { _deleteStorage } from "src/app/utils/local-storage";
import { AppService } from "../../../services/app.service";

@Component({
  selector: "app-manual-replace",
  templateUrl: "./manual-replace.page.html",
  styleUrls: ["./manual-replace.page.scss"],
})
export class ManualReplacePage implements OnInit {
  @Input() public acticereplace: any;

  public appPages = [
    {
      title: "ค้นหาใบกำกับภาษี",
      url: "/replace",
      icon: "mail",
      action: 1,
    },
    {
      title: "ข้อมูลผู้ซื้อ",
      url: "/replace-select-taxinvoice",
      icon: "paper-plane",
      action: 2,
    },
    {
      title: "ตรวจสอบข้อมูลใบกำกับภาษี",
      url: "/replace-checkdata-taxinvoice",
      icon: "heart",
      action: 3,
    },
    {
      title: "บันทึกและส่งข้อมูล",
      url: "/replace-savedata-taxinvoice",
      icon: "trash",
      action: 4,
    },
    {
      title: "ออกใบกำกับภาษีทดแทนสำเร็จ",
      url: "/replace-preview",
      icon: "trash",
      action: 5,
    },
  ];

  noname = "";
  constructor(
    public router: Router,
    public appService: AppService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.appService.active.subscribe((value) => {
      this.acticereplace = value;
    });
    this.route.queryParams.subscribe((params) => {
      if (params.noName === "no_replace") {
        this.noname = params.noName;
      } else {
        this.noname = "";
      }
    });
  }

  ionViewDidEnter() {
    _deleteStorage(STORAGE.DATA_SEARCH_REPLACE)
    _deleteStorage(STORAGE.DATA_PREVIEW_REPLACE)
    _deleteStorage(STORAGE.DATA_CHECK_REPLACE)
  }

  clickMenu(a) {
    if (a.action === 1) {
      this.appService.setActive(a.action)
      this.ionViewDidEnter();
      if (this.noname !== "") {
        this.router.navigate([a.url], {
          queryParams: { noName: "no_replace", selectedIndex: "4" },
        });
      } else {
        this.router.navigate([a.url]);
      }
    }
  }
}
